module.exports = __webpack_public_path__ + "static/media/tv.30b030d9.svg";